import api from '../_api';

const actions = {
    teamRequest: ({commit, dispatch}) => {

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.teams()
                .then((resp) => {
                    commit('TEAM_SUCCESS', resp.data.data);
                    // resolve(resp.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('TEAM_ERROR', errors);
                    // reject(err.response);
                });
        })
    },
    gameRequest: ({commit, dispatch}, payload) => {
        let data = {
            teamTid: payload.teamTid
        };

        return new Promise((resolve, reject) => {
            // commit('TEAM_LOADING');

            api.games(data)
                .then((resp) => {
                    // commit('TEAM_SUCCESS', resp.data.data);
                    resolve(resp.data.data);
                })
                .catch((err) => {
                    let errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;

                    commit('TEAM_ERROR', errors);
                    reject(err.response);
                });
        })
    },
    saveTeam: ({ commit, dispatch }, payload) => {
        let data = {
            singletColour: payload.singletColour,
            numberColour: payload.numberColour,
            playersNumber: payload.playersNumber,
            teamTid: payload.teamTid
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.saveTeam(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    sendNewPlayers: ({ commit, dispatch }, payload) => {
        let data = {
            players: payload.players,
            teamTid: payload.teamTid
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.sendNewPlayers(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    sendNewTempPlayers: ({ commit, dispatch }, payload) => {
        let data = {
            tempplayers: payload.tempplayers,
            teamTid: payload.teamTid
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.sendNewTempPlayers(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                    commit("CLEAR_TEAM_ERRORS");
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    sendGameForfeit: ({ commit, dispatch }, payload) => {
        let data = {
            game: payload.game,
            teamTid: payload.teamTid
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.sendGameForfeit(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                    commit("CLEAR_TEAM_ERRORS");
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    sendRemovePlayer: ({ commit, dispatch }, payload) => {
        let data = {
            teamTid: payload.teamTid,
            playerMid: payload.playerMid
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.sendRemovePlayer(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    sendRemovePosition: ({ commit, dispatch }, payload) => {
        let data = {
            teamTid: payload.teamTid,
            position: payload.position
        };

        return new Promise((resolve, reject) => {
            commit('TEAM_LOADING');

            api.sendRemovePosition(data)
                .then(resp => {
                    // dispatch("team/teamRequest", null, { root: true });
                    resolve(resp.data.data);
                })
                .catch(err => {
                    let errors = err.response.data;

                    commit("TEAM_ERROR", errors);
                    reject(err.response);
                });
        })
    },
    clearTeamErrors:({commit}) => {
        commit('CLEAR_TEAM_ERRORS');
    },
}

export default actions
